module.exports = __webpack_public_path__ + "img/developpement.8efceed2.jpg";